'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkDataForKey = exports.checkDataForKey = function checkDataForKey(data, keyword) {
  var pluralEnding = 's';
  if (keyword.slice(-1) === 'y') {
    pluralEnding = 'ies';
    keyword = keyword.substring(0, keyword.length - 1);
  }
  return data && data[keyword] || data && data[keyword + pluralEnding] || data;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/api-migration-fill.js
// module id = 610
// module chunks = 0